var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07865 0.852356L31.2505 0.852356C32.0217 0.852356 32.6686 1.11882 33.1912 1.65176C33.7138 2.18469 33.9742 2.80645 33.9724 3.51703C33.9724 3.73909 33.9388 3.97269 33.8717 4.21784C33.8046 4.46299 33.702 4.69571 33.5641 4.91599L19.4782 26.6331C19.206 27.0328 18.8658 27.333 18.4575 27.5338C18.0492 27.7345 17.6182 27.834 17.1646 27.8322C16.7109 27.8304 16.2799 27.7309 15.8717 27.5338C15.4634 27.3366 15.1231 27.0363 14.8509 26.6331L0.765022 4.91599C0.628925 4.69393 0.526398 4.46121 0.457443 4.21784C0.388489 3.97447 0.354919 3.74086 0.356735 3.51703C0.356735 2.80645 0.618038 2.18469 1.14065 1.65176C1.66325 1.11882 2.30926 0.852356 3.07865 0.852356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f4efe30f191a82f52e895af7ecea5677.svg";
export { ForwardRef as ReactComponent };